export default __webpack_public_path__ + "media/images/booster_icon-4eb295f02f26293b8f9b9f6710ebd786.png";